import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import moment from 'moment';

export class AccountBalances extends AbstractReport {

    getCheckOut(value) {

        if (this.same_day_checkout) {

            return moment(value).subtract(1, 'day').format('YYYY-MM-DD');
        }

        return value;
    }
}

AccessorsMutatorsDecorator(
    'reservation_id',
    'guest_id',
    'ident',
    'guest_name',
    'check_in',
    'check_out',
    'status',
    'number_of_nights',
    'rooms',
    'reservation_source',
    'credit_cards',
    'total_amount',
    'paid_amount',
    'balance',
    'created_at',
    'same_day_checkout',
)(AccountBalances);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/account-balances.model.js